export default {
    fetching: "fetching",
    error: "error",
    success: "success"
};
